import { isEmpty } from 'lodash';

import { MessageMedium } from 'modules/graphql/types';
import { useLocaleSettingsContext } from 'modules/campaigns/lib/contexts/LocaleSettingsContext';
import { MESSAGE_MEDIUM_CONTENT_MAPPER } from 'modules/campaigns/lib/utils/iconUtils';
import { BusinessInititatedField } from 'modules/templateEditor/EditWhatsApp/TemplateTypeField';

import { TemplateDetailsBlock, TemplateDetailsContainer } from './EditableHeader.styled';
import { SubHeaderCampaignFlow } from './SubHeaderCampaignFlow';
import { SubHeaderLocales } from './SubHeaderLocales';
import { useCampaignQueryContext } from '../../context/CampaignQueryContext';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { useTemplateQueryContext } from '../../context/TemplateQueryContext';
import { SubHeaderPlacement } from './SubHeaderPlacement';
import { SubHeaderWhatsAppType } from './SubHeaderWhatsAppType';
import { SubHeaderApproval } from './SubHeaderApproval';

export const SubHeader = () => {
  const { campaignId, templateId } = useQueryParamContext();
  const { campaign } = useCampaignQueryContext();
  const { locales } = useLocaleSettingsContext();
  const { medium } = useTemplateQueryContext();
  const isCampaignFlow = !!campaignId;
  const { Icon: MessageIcon, displayName: messageDisplayName } =
    MESSAGE_MEDIUM_CONTENT_MAPPER[medium as MessageMedium] || {};

  /** Checking if campaign flow for locale subheader info because
   *  locales info is displayed as the last block when not in campaign flow
   *  and is sandwiched within campaign flow information if campaign flow
   */
  return (
    <TemplateDetailsContainer>
      <TemplateDetailsBlock>
        <MessageIcon height={16} width={16} /> &nbsp;{messageDisplayName}
      </TemplateDetailsBlock>
      <SubHeaderPlacement />
      <SubHeaderWhatsAppType />
      {!campaign.id && <TemplateDetailsBlock>{`ID: ${templateId}`}</TemplateDetailsBlock>}
      {isCampaignFlow && <SubHeaderCampaignFlow />}
      {!isEmpty(locales) && !campaign.id && <SubHeaderLocales />}
      <BusinessInititatedField>
        <SubHeaderApproval />
      </BusinessInititatedField>
    </TemplateDetailsContainer>
  );
};
